import axios from "../http";

class GoodsInfo {
  /* 查看货主的商品信息 */
  static getGoodsInfo(pageNo, customerId, queryStrValue) {
    const url = `/zwy/api/customer/goods/list?pageNo=${pageNo}&customerId=${customerId}&queryStrValue=${queryStrValue}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 商品信息导入 */
  static postUploadGoodsInfoExcel(data) {
    const url = "/zwy/api/upload/customer/goods";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default GoodsInfo;